/*
 * @description: vue-router初始化，并加载config中的router配置
 * @author: xuy
 * @since: 2020-03-31 11:09:22
 * @version: 1.0
 */
import Vue from 'vue'
import Router from 'vue-router'
import routers from '@/config/router'
import envVariables from '@/env-variables'

Vue.use(Router)

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  base: envVariables.baseUrl,
  mode: 'history',
  routes: routers
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
